/* eslint-disable multiline-ternary */

import { FC, useEffect, useState } from 'react';
import classNames from 'classnames';
import Typography from 'src/components/common/typography/Typography';

import './profilePicture.scss';
import { TProfilePictureProps } from './profilePicture.type';
import Skeleton from '../skeleton/Skeleton';

/*
 ** Component to representative text incase the image is not available or failed loading
 */
const ProfilePicture: FC<TProfilePictureProps> = ({
  url = '',
  fallback,
  className,
  userType,
  onClick,
  ...rest
}: TProfilePictureProps) => {
  const [isImageValid, setIsImageValid] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    if (!url) {
      setIsImageValid(false);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    const img = new Image();
    img.src = url;

    img.onload = () => {
      setIsImageValid(true);
      setIsLoading(false);
    };

    img.onerror = () => {
      setIsImageValid(false);
      setIsLoading(false);
    };

    // Cleanup function (prevents stale state updates)
    return () => {
      img.onload = null;
      img.onerror = null;
    };
  }, [url]);
  function handleNavigate() {
    if (onClick) {
      onClick();
    }
  }

  return (
    <div
      className={classNames(
        'profile-picture-component',
        `profile-picture-component--${userType}`,
        className
      )}
      style={onClick ? { cursor: 'pointer' } : { cursor: 'default' }}
      onClick={handleNavigate}
      {...rest}
    >
      {isImageValid && !isLoading ? (
        <img key={url} src={url || ''} />
      ) : isLoading ? (
        <Skeleton />
      ) : (
        <Typography
          as="h3"
          variant="body-1"
          fontWeight="semiBold"
          className="profile-picture-component__error"
        >
          {fallback}
        </Typography>
      )}
    </div>
  );
};

ProfilePicture.defaultProps = {
  url: ''
};

export default ProfilePicture;
